import { once } from "@/http";

class OnceService {
   async simDetailsByImei(imei) {
    return await once.get("/imei_status/" + imei);
  }
}
export default new OnceService();
